module.exports = __webpack_public_path__ + "static/img/icons-delivered.930017d0.svg";